import React from 'react';
import { FaCode, FaSketch, FaAndroid } from 'react-icons/fa';
export default [
  {
    id: 1,
    icon: <FaCode className='service-icon' />,
    title: 'web development',
    text: `I'm baby meditation tofu chillwave, distillery messenger bag thundercats chicharrones kale chips gochujang. Banh mi direct trade marfa salvia.`,
  },
  {
    id: 2,
    icon: <FaSketch className='service-icon' />,
    title: 'web design',
    text: `I'm baby meditation tofu chillwave, distillery messenger bag thundercats chicharrones kale chips gochujang. Banh mi direct trade marfa salvia.`,
  },
  {
    id: 3,
    icon: <FaAndroid className='service-icon' />,
    title: 'Blockchain',
    text: `I'm baby meditation tofu chillwave, distillery messenger bag thundercats chicharrones kale chips gochujang. Banh mi direct trade marfa salvia.`,
  },
];
